import { type FormInstance, Form } from 'antd';
import { type Moment } from 'moment';

import { UTCDatePicker } from 'components/UTCDatePicker';
import { isScheduleDateOutOfOrder } from 'utils/workOrderScheduleDates';

type Props = {
  slug: string;
  otherSlug: string; // the other schedule date field
  form: FormInstance<any>;
  testId?: string;
  disabled?: boolean;
  // value and onChange come from the wrapping Form.Item
  value?: Moment | null;
  onChange?: (date: Moment | null, dateString: string) => void;
};

/**
 * Date picker for a Work Order's Start Date / End Date: days that would put the End Date before the
 * Start Date can't be picked.
 */
export const ScheduleDatePicker = ({
  slug,
  otherSlug,
  form,
  testId,
  disabled,
  value,
  onChange,
}: Props) => {
  const otherDate = Form.useWatch(otherSlug, form);

  return (
    <UTCDatePicker
      data-testid={testId}
      disabled={disabled}
      value={value}
      onChange={onChange}
      disabledDate={(date: Moment) => isScheduleDateOutOfOrder(slug, date, otherDate)}
    />
  );
};
